import MapMaker from "../utils/MapMaker";
import {gsap} from "../../lib/gsap";
export default class BlockMap {

	static init() {

		let blockMaps = document.querySelectorAll('.map-inner');

		if (!blockMaps) {
			return;
		}

		blockMaps.forEach((blockMap) => {
			gsap.to(".map-wrapper", {
				scrollTrigger: {
					trigger: ".map-container",
					start: "top top",
					end: "bottom bottom",
					toggleActions: "play none none none",
					pin: true,
					pinSpacing: false,
				},
			});
			let markers = blockMap.querySelectorAll('.map-marker');

			if (blockMap.dataset.type === "static") {

				MapMaker.createStaticMap(blockMap, markers);

			} else {
				console.log(blockMap);
				let map = MapMaker.createDynamicMap(blockMap);

				if (blockMap.dataset.zoom) {
					map.setZoom(parseInt(blockMap.dataset.zoom));
				}

				markers.forEach((m) => {
					MapMaker.createMarker(m, map);
				});

				MapMaker.updateBounds(map);
			}
		});
	}
}
